<template>
  <div class="chat-footer__wrapper">
    <div
      class="chat-footer chat-footer__blocked"
      v-if="currentUser && (currentUser.blocked || locked)"
    >
      {{ locked ? "Chat is temporarily locked" : "You are blocked" }}
    </div>
    <div class="chat-footer" v-else-if="currentUser && !currentUser.blocked">
      <v-textarea
        @keydown.enter="sendMessage"
        auto-grow
        rows="1"
        class="chat-footer__input"
        placeholder="Say something"
        :value="value"
        @input="$emit('input', $event)"
        :maxlength="maxLength"
      ></v-textarea>
      <div class="chat-footer__actions">
        <v-menu left offset-x content-class="chat-footer__emoji">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon>
              <v-icon>
                $emoji
              </v-icon>
            </v-btn>
          </template>
          <div @click.stop>
            <VEmojiPicker @select="selectEmoji" />
          </div>
        </v-menu>
        <div>
          <span class="chat-footer__max-length">{{ value.length }} / 200</span>
          <v-btn @click="sendMessage" icon>
            <v-icon>
              $send
            </v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="chat-footer chat-footer__login" v-else>
      <v-btn outlined @click="openAuthModal">Sign in</v-btn>
    </div>
  </div>
</template>

<script>
import { stripMessage } from "@/utils";
export default {
  name: "ChatFooter",
  props: {
    value: String,
    locked: Boolean,
  },
  data() {
    return {
      maxLength: 200,
    };
  },
  methods: {
    openAuthModal() {
      this.$root.$emit("auth");
    },
    selectEmoji({ data }) {
      this.$emit("input", this.value + data);
    },
    async sendMessage(event) {
      if (!event.shiftKey && this.value.replace(/(\s|\n)+/g, "").length) {
        event.preventDefault();
        const inputValue = stripMessage(this.value);

        this.sendWs(inputValue);

        this.$emit("clear");
      }
    },
    sendWs(inputValue) {
      const message = {
        body: inputValue,
        user_name: this.currentUser.full_name,
        token: this.token,
      };

      this.$cable.perform({
        channel: "ChatChannel",
        action: "send_message",
        data: message,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.chat-footer__wrapper {
}
.chat-footer {
  width: 100%;
  height: 100%;
  padding: 0 15px;
}

.chat-footer__login,
.chat-footer__blocked {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.chat-footer__input {
  margin-top: -5px;
}

.chat-footer__actions {
  display: flex;
  justify-content: space-between;
  margin: -20px -8px 0 -8px;
}

.chat-footer__max-length {
  color: #333;
  font-size: 0.75em;
  margin: 10px;
}

.chat-footer__emoji {
  margin-left: -20px;
}
</style>
